import { defineMessage } from 'react-intl'

// The fonts stored here correspond to actual, physical characters that are being used for embossing. Each font comes with constraints on the characters that can be used.

// All fonts generally support these characters
const BASE_CHARSET = "abcdefghijklmnopqrstuvwxyzäöüßABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.,!?& "

// Each font comes with this many multiples for each character. Meaning, each character is available this many times, but no more. For example, "a" is available 4 times in the "times-new-roman" font. If a text is chosen for this font, and it contains more than 5 "a" 's, the text cannot get embossed.
const MULTIPLE_CHARACTERS_PER_FONT = 4

const FONT_OPTIONS = [
    {
        label: defineMessage({ defaultMessage: "Serif" }),
        value: "times-new-roman",
        fontStack: '"Times New Roman", Times, serif',
        supportedCharacters: BASE_CHARSET,
        maxCharacterRepeats: MULTIPLE_CHARACTERS_PER_FONT
    }, {
        label: defineMessage({ defaultMessage: "Sans-Serif" }),
        value: "arial",
        fontStack: '"Arial", Helvetica, sans-serif',
        supportedCharacters: BASE_CHARSET,
        maxCharacterRepeats: MULTIPLE_CHARACTERS_PER_FONT,
        default: true
    }
]

export const getFontOptionByValue = (value) => FONT_OPTIONS.find(font => font.value === value)

export const validateTextForFont = (text, font, maxChars) => {
    let errors = [];
    if (!FONT_OPTIONS.includes(font)) {
        errors.push({
            text: defineMessage({ defaultMessage: "Diese Font wird nicht unterstützt." })
        })
    }

    const supportedCharacters = font.supportedCharacters
    const maxCharacterRepeats = font.maxCharacterRepeats

    // first, check if the text contains any characters that are not supported by the font
    const unsupportedCharacters = [...new Set(text.split('').filter(char => !supportedCharacters.includes(char)))]

    if (unsupportedCharacters.length > 0) {
        errors.push({
            text: defineMessage({ defaultMessage: "Diese Zeichen werden nicht von der ausgewählten Font unterstützt: " }),
            unsupportedCharacters
        })
    }

    // next, check if the text exceeds the maximum allowed number of characters, but don't count the "." character!
    const textLength = text.replaceAll('.', '').length
    if (textLength > maxChars) {
        const exceedingCharacters = text.substring(maxChars)
        errors.push({
            text: defineMessage({ defaultMessage: "Dein Text überschreitet die maximale Anzahl erlaubter Zeichen." }),
            exceedingCharacters: exceedingCharacters.length
        })
    }

    // next, check if the text contains any characters that are repeated more than the maximum allowed number of times
    const characterCounts = {}
    text.split('').forEach(char => {
        // don't count spaces!
        if (char === ' ') return

        characterCounts[char] = characterCounts[char] ? characterCounts[char] + 1 : 1
    })

    const repeatingCharacters = Object.keys(characterCounts).filter(char => characterCounts[char] > maxCharacterRepeats)
    if (repeatingCharacters.length > 0) {
        errors.push({
            text: defineMessage({ defaultMessage: "Die maximale Anzahl an Wiederholungen folgender Zeichen wurde überschritten:" }),
            repeatingCharacters
        })
    }

    if (errors.length > 0) {
        return {
            isvalid: false,
            errors
        }
    } else {
        return {
            isvalid: true
        }
    }
}

export default FONT_OPTIONS